
import respUtility from '@/mixins/respUtility';

export default {
  name: 'BaseBreadcrumbs',
  mixins: [respUtility],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
    isPLP: {
      type: Boolean,
      default: false,
    },
    isBrands: {
      type: Boolean,
      default: false,
    },
    isAbouUs: {
      type: Boolean,
      default: false,
    },
    isOpenPosition: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.scrollToEnd();
  },
  watch: {
    breadcrumbs() {
      this.$nextTick(this.scrollToEnd);
    },
  },
  methods: {
    scrollToEnd() {
      if (!(this.$device.isMobileOrTablet || this.isTouchDevice) || !this.$refs?.scroll?.$refs?.content) {
        return;
      }
      this.$refs.scroll.$refs.content.scrollLeft = this.$refs.scroll.$refs.content.scrollWidth;
    },
    getTitle(item) {
      let title;
      if (item.slug === '' && this.isAbouUs) {
        title = item?.name;
      } else if (item.slug === '' && !this.isAbouUs) {
        title = 'Go To Home Page';
      } else if (item.slug === 'about-us') {
        title = item?.name;
      } else if (item.slug === 'careers' && this.isOpenPosition) {
        title = item?.name;
      } else {
        title = null;
      }
      return title;
    },
  },
};
